import { render, staticRenderFns } from "./CombatCardUpgrade.vue?vue&type=template&id=f028134e&scoped=true&"
import script from "./CombatCardUpgrade.vue?vue&type=script&lang=js&"
export * from "./CombatCardUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f028134e",
  null
  
)

export default component.exports